function isOperacionAlquiler(operacion) {
  const op = String(operacion || "").toLowerCase().trim();
  return op === "alquiler" || op === "alquiler vacacional";
}

/** Misma lógica que backend resolverCarteraPropiedad (listado Propiedades). */
export function resolverCarteraPropiedad(p) {
  const etapa = String(p.etapa_pipeline || "").toLowerCase().trim();
  if (etapa === "eliminado") return "eliminadas";
  if (etapa === "frio") return "ocultas";
  if (p.disponible === false && p.disponible_desde != null && String(p.disponible_desde).trim() !== "") {
    const raw = String(p.disponible_desde);
    const d = new Date(raw.includes("T") ? raw : `${raw}T12:00:00`);
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);
    d.setHours(0, 0, 0, 0);
    if (!Number.isNaN(d.getTime()) && d > hoy) return "no_disponibles";
  }
  if (p.disponible === true) {
    // No existe estado "privadas": publicar_web solo controla si se publica en la web,
    // no si la propiedad está activa en el CRM.
    if (isOperacionAlquiler(p.operacion)) return "alquiler";
    return "activas";
  }
  if (p.publicar_web === true) return "reservadas";
  return "vendidas";
}

export const ETIQUETA_ESTADO_PROPIEDAD = {
  ocultas: { text: "Oculta", bg: "#7c3aed" },
  no_disponibles: { text: "No disponible", bg: "#ea580c" },
  reservadas: { text: "Reservada", bg: "#eab308", color: "#1c1917" },
  vendidas: { text: "Vendida/Alquilada", bg: "#dc2626" },
  eliminadas: { text: "Eliminada", bg: "#000000" },
};

/** @param {string|null|undefined} carteraVista — pestaña del listado (activas, vendidas, …) */
export function etiquetaEstadoPropiedad(p, carteraVista) {
  const cartera = resolverCarteraPropiedad(p);
  // Activas/Alquiler incluyen también las "No disponible" temporales (mismo subgrupo que
  // se ve en su propia pestaña), así que esa etiqueta sí debe mostrarse aquí; el resto de
  // etiquetas (Oculta, Reservada, Vendida/Alquilada, Eliminada) no aplican porque esas propiedades
  // no forman parte de Activas/Alquiler.
  if ((carteraVista === "activas" || carteraVista === "alquiler") && cartera !== "no_disponibles") return null;
  if (cartera === "activas" || cartera === "alquiler") return null;
  if (cartera === "vendidas") {
    const alq = isOperacionAlquiler(p?.operacion);
    return { text: alq ? "Alquilada" : "Vendida", bg: "#dc2626" };
  }
  return ETIQUETA_ESTADO_PROPIEDAD[cartera] || null;
}
